import { render, staticRenderFns } from "./TutorialModal.vue?vue&type=template&id=2437c536&scoped=true&"
import script from "./TutorialModal.vue?vue&type=script&lang=js&"
export * from "./TutorialModal.vue?vue&type=script&lang=js&"
import style0 from "./TutorialModal.vue?vue&type=style&index=0&id=2437c536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437c536",
  null
  
)

export default component.exports